/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { CartProduct } from '../model/cartProduct';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

import { UserAddress } from '../model/userAddress';
@Injectable()
export class CartProductService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Get all product in cart
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiMyCartProductsGet(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public apiMyCartProductsGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiMyCartProductsGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiMyCartProductsGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    const apiUrl = `${this.basePath}/api/myCartProducts`;

    return this.httpClient.request<any>('get', apiUrl, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Remove product ou of cart
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiMyCartProductsIdDelete(
    id: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiMyCartProductsIdDelete(
    id: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiMyCartProductsIdDelete(
    id: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiMyCartProductsIdDelete(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiMyCartProductsIdDelete.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>(
      'delete',
      `${this.basePath}/api/myCartProducts/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Edit quantity of product in cart
   *
   * @param id
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiMyCartProductsIdPut(
    id: string,
    body?: CartProduct,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiMyCartProductsIdPut(
    id: string,
    body?: CartProduct,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiMyCartProductsIdPut(
    id: string,
    body?: CartProduct,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiMyCartProductsIdPut(
    id: string,
    body?: CartProduct,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiMyCartProductsIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>(
      'put',
      `${this.basePath}/api/myCartProducts/${encodeURIComponent(String(id))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Add product to cart
   *
   * @param productId
   * @param quantity
   * @param subTypeId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiMyCartProductsPost(
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    myEquipmentId?: string,
    sourceType?: string,
    sourceRefId?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiMyCartProductsPost(
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    myEquipmentId?: string,
    sourceType?: string,
    sourceRefId?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiMyCartProductsPost(
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    myEquipmentId?: string,
    sourceType?: string,
    sourceRefId?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiMyCartProductsPost(
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    myEquipmentId?: string,
    sourceType?: string,
    sourceRefId?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (productId !== undefined && productId !== null) {
      queryParameters = queryParameters.set('productId', <any>productId);
    }
    if (quantity !== undefined && quantity !== null) {
      queryParameters = queryParameters.set('quantity', <any>quantity);
    }
    if (subTypeId !== undefined && subTypeId !== null) {
      queryParameters = queryParameters.set('subTypeId', <any>subTypeId);
    }
    if (myEquipmentId !== undefined && myEquipmentId !== null) {
      queryParameters = queryParameters.set('myEquipmentId', <any>myEquipmentId);
    }
    if (sourceType !== undefined && sourceType !== null) {
      queryParameters = queryParameters.set('sourceType', <any>sourceType);
    }
    if (sourceRefId !== undefined && sourceRefId !== null) {
      queryParameters = queryParameters.set('sourceRefId', <any>sourceRefId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>('post', `${this.basePath}/api/myCartProducts`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Export cart products to PDF
   *
   * @param requestBody Cart product data to export
   * @param isVat Whether to include VAT in the invoice
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiMyCartProductsExportPdfPost(
    requestBody: UserAddress,
    isVat?: boolean,
    voucherCode?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Blob>;
  public apiMyCartProductsExportPdfPost(
    requestBody: UserAddress,
    isVat?: boolean,
    voucherCode?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Blob>>;
  public apiMyCartProductsExportPdfPost(
    requestBody: UserAddress,
    isVat?: boolean,
    voucherCode?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Blob>>;
  public apiMyCartProductsExportPdfPost(
    requestBody: UserAddress,
    isVat?: boolean,
    voucherCode?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (requestBody === null || requestBody === undefined) {
      throw new Error(
        'Required parameter requestBody was null or undefined when calling apiMyCartProductsExportPdfPost.'
      );
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (isVat !== undefined && isVat !== null) {
      queryParameters = queryParameters.set('isVat', String(isVat));
    }
    if (voucherCode !== undefined && voucherCode !== null && voucherCode !== '') {
      queryParameters = queryParameters.set('voucherCode', voucherCode);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/pdf'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Blob>('post', `${this.basePath}/api/myCartProducts/exportPdf`, {
      body: requestBody,
      params: queryParameters,
      responseType: 'blob' as 'json',
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  //  Admin adds product to customer's cart
  public apiCartProductsAddForCustomerPost(
    userId: string,
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiCartProductsAddForCustomerPost(
    userId: string,
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiCartProductsAddForCustomerPost(
    userId: string,
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiCartProductsAddForCustomerPost(
    userId: string,
    productId?: string,
    quantity?: number,
    subTypeId?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error(
        'Required parameter userId was null or undefined when calling apiCartProductsAddForCustomerPost.'
      );
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    queryParameters = queryParameters.set('userId', <any>userId);
    if (productId !== undefined && productId !== null) {
      queryParameters = queryParameters.set('productId', <any>productId);
    }
    if (quantity !== undefined && quantity !== null) {
      queryParameters = queryParameters.set('quantity', <any>quantity);
    }
    if (subTypeId !== undefined && subTypeId !== null) {
      queryParameters = queryParameters.set('subTypeId', <any>subTypeId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>('post', `${this.basePath}/api/cartProducts/addForCustomer`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  public apiUserCartProductsGet(
    userId: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiUserCartProductsGet(
    userId: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiUserCartProductsGet(
    userId: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiUserCartProductsGet(
    userId: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error(
        'Required parameter userId was null or undefined when calling apiUserCartProductsGet.'
      );
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    queryParameters = queryParameters.set('userId', <any>userId);

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>('get', `${this.basePath}/api/userCartProducts`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
